const styles = theme => ({
  root: {
    gridColumnStart: 2,
    padding: theme.spacing(5, 0),
  },
  paper: {
    padding: theme.spacing(0, 2, 2, 2),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > span': {
      marginRight: theme.spacing(1),
    },
  },
  dashboardContainer: {
    paddingTop: theme.spacing(3),
  },
  reportContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    marginBottom: '1rem',
  },
  hide: {
    display: 'none',
  },

  dashboad_secion: {
        background: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '20px',
        padding: '24px',
        marginBottom: '3rem',
        boxShadow: '0 8px 32px rgba(15, 23, 42, 0.08), 0 2px 8px rgba(15, 23, 42, 0.04)',
        zIndex: 11,
        position: 'relative'
  }

})

export default styles